<template>
    <div class="options-navig-column options-biggest-column selected-client" @click="this.$helper.addFocus">
        <select class="client-select" :class="`clients_input`">
            <option></option>
        </select>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function() {
        return {
            searching: false,     
            clients: {},
            selectValues: [],
            selected: undefined,
        }
    },
    props: {
        inputType: {
            type: String,
            required: true,
        },
    },
    created: function() {
        let vueThis = this;   

        vueThis.clients = vueThis.$store.state.allClients;
        $.each(vueThis.clients, function(index, name) {     
            vueThis.selectValues.push({
                    'id': index,
                    'text': name
                }
            );
        });
 
        $(function() {
            $(`.clients_input`).select2({
                width: '100%',                
                scrollAfterSelect: true,
                data: vueThis.selectValues,
                templateResult: vueThis.formatDropList,
                templateSelection: vueThis.formatSelectedItem,     
                sorter: function(data) {
                    return data.sort(function(a, b) {
                        return a.text.localeCompare(b.text);
                    });
                },
                escapeMarkup: function(markup) {
                    return markup;
                },     
                dropdownCssClass: 'country-picker',
                placeholder: vueThis.$helper.trans('Please_select_client'),
            }); 
            
            $(`.clients_input`).on('select2:select', function() {
                vueThis.selectClient($(this).val());
            });

            vueThis.reselectView();
        });
    },
    methods: {
        selectClient: function(clientId = null){      
            this.$store.state.temporaryClientDiscounts = {}; 
            this.$store.state.manualDiscounts.transportation = '';
            this.$store.state.manualDiscounts.privateAddress = '';
            this.$store.state.manualDiscounts.extendedArea = '';
            this.$store.state.manualDiscounts.additionalHandling = '';
            
            let setClientId = clientId;

            if (clientId == 0) {
                setClientId = null;
            }

            this.$store.state.clientId = setClientId;
            this.$helper.getClientDiscounts(setClientId);
        },
        formatDropList: function(client) {        
            if(client.id === '' || client.id === undefined) {
                return;
            }        
   
            return `
                <div style="display: flex; align-items: center; padding-bottom: 5px; padding-top: 5px;">
                    <span class="country-label" style="padding-left: 10px;">${client.text}</span>
                </div>
            `;
        },
        formatSelectedItem: function(client) {   
            return `
                <div style="display: flex; align-items: center;">
                    <span class="country-label selected-country">${client.text}</span>
                </div>
            `;
        },
        reselectView: function(){    
            this.selected = this.$store.state.clientId;
            if(this.clients[this.selected] !== undefined) {  
                $(`.clients_input`).val(this.selected).trigger('change.select2');
            } else{         
                $(`.clients_input`).val(null).trigger('change.select2');
            }
        },
    },
}
</script>
